import { httpClient } from '@/shared/api/httpClient'
import type { PageResponse } from '@/shared/api/PageResponse'

import type {
  NotificationResponse,
  NotificationTab,
  UnreadCountResponse,
} from '../types/notification.types'

/** `tab` solo si viene: sin ella, el servidor trata todos los avisos (como antes). */
const tabParam = (tab?: NotificationTab) => (tab ? { tab } : {})

export const notificationsApi = {
  list: (page = 0, size = 10, tab?: NotificationTab): Promise<PageResponse<NotificationResponse>> =>
    httpClient
      .get<PageResponse<NotificationResponse>>('/me/notifications', {
        params: { page, size, ...tabParam(tab) },
      })
      .then((r) => r.data),

  unreadCount: (): Promise<UnreadCountResponse> =>
    httpClient.get<UnreadCountResponse>('/me/notifications/unread-count').then((r) => r.data),

  markAsRead: (id: number): Promise<void> =>
    httpClient.post<void>(`/me/notifications/${id}/read`).then(() => undefined),

  /** Varios a la vez (un grupo de novedades al desplegarlo). */
  markSeveralAsRead: (ids: number[]): Promise<void> =>
    httpClient.post<void>('/me/notifications/mark-read', { ids }).then(() => undefined),

  markAllAsRead: (tab?: NotificationTab): Promise<void> =>
    httpClient
      .post<void>('/me/notifications/mark-all-read', null, { params: tabParam(tab) })
      .then(() => undefined),

  deleteAllRead: (tab?: NotificationTab): Promise<void> =>
    httpClient
      .delete<void>('/me/notifications/read', { params: tabParam(tab) })
      .then(() => undefined),
}
